export const PREFIX = 'CaIntegration';
export const IS_ENABLED = PREFIX + '.IsEnabled';
export const CHAT_ENDPOINT_ADDRESS = PREFIX + '.ChatEndpointAddress';
export const TOKEN_ENDPOINT_ADDRESS = PREFIX + '.TokenEndpointAddress';
export const CLIENT_ID = PREFIX + '.ClientId';
export const CLIENT_SECRET = PREFIX + '.ClientSecret';
export const START_DATE = PREFIX + '.StartDate';
